import { render, staticRenderFns } from "./videoclaim.vue?vue&type=template&id=446b878e&scoped=true&"
import script from "./videoclaim.vue?vue&type=script&lang=js&"
export * from "./videoclaim.vue?vue&type=script&lang=js&"
import style0 from "./videoclaim.vue?vue&type=style&index=0&id=446b878e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b878e",
  null
  
)

export default component.exports